import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getToken } from './services/tokenService';

const API_HOSTS = [
  'api.ukpetitiontracker.com',
  'timedata.ukpetitiontracker.com',
  'localhost:3002',
  'localhost:5001',
];

// Keep a reference to the real fetch before intercepting
window._originalFetch = window.fetch.bind(window);

const TIMEDATA_HOSTS = ['timedata.ukpetitiontracker.com', 'localhost:5001'];

window.fetch = async function interceptedFetch(input, init = {}) {
  let url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  const isApiCall = API_HOSTS.some(host => url.includes(host));

  if (isApiCall) {
    const token = await getToken();
    const isTimedata = TIMEDATA_HOSTS.some(host => url.includes(host));

    if (isTimedata) {
      // Use query param for timedata — avoids CORS preflight (no custom header needed)
      const sep = url.includes('?') ? '&' : '?';
      url = url + sep + '_t=' + encodeURIComponent(token);
      if (typeof input !== 'string') input = url;
      else input = url;
    } else {
      // Use header for Node.js backend
      init = {
        ...init,
        headers: { ...init.headers, 'X-App-Token': token },
      };
      if (input instanceof Request) {
        input = new Request(input, init);
        init = undefined;
      }
    }
  }

  return window._originalFetch(input, init);
};

// The server injects a plain-HTML copy of the page for crawlers and for
// visitors without JavaScript. Once React is running it is redundant, so it is
// removed before the app paints — otherwise the content would appear twice.
const seoFallback = document.getElementById('seo-fallback');
if (seoFallback) seoFallback.remove();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);